import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VerticalDividedDialog = _resolveComponent("VerticalDividedDialog");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card = _resolveComponent("v-card");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", null, [
        _cache[14] || (_cache[14] = _createElementVNode("div", null, [
            _createElementVNode("a", { href: "https://www.notion.so/barogohq/0a7d0167f4f94cf08e0919d32a95991b?pvs=4" }, " 노션 링크 (vdi만 가능..) "),
            _createTextVNode(" 허브컨트롤룸 프론트엔드 홈 - 설계문서 - 중앙 분리 다이얼로그 탬플릿 ")
        ], -1 /* CACHED */)),
        _createVNode(_component_VerticalDividedDialog, {
            "is-open": _ctx.isDividedOpen,
            "on-cancel": _ctx.closeDialog,
            "on-apply": _ctx.closeDialog,
            "dialog-css-class": _ctx.dialogCssClass,
            "is-divided": _ctx.isDivided,
            "has-footer": _ctx.hasFooter
        }, null, 8 /* PROPS */, ["is-open", "on-cancel", "on-apply", "dialog-css-class", "is-divided", "has-footer"]),
        _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" width-lg ratio-5-5 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [0]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" width-lg ratio-4-6 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [1]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" width-lg ratio-3-7 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [2]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" width-md ratio-5-5 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [3]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            danger: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" width-md ratio-4-6 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [4]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            danger: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" width-md ratio-3-7 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [5]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            danger: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" width-sm ratio-5-5 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [6]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            info: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" width-sm ratio-4-6 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [7]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            info: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" width-sm ratio-3-7 ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [8]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            info: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDividedDialogBtn }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode(" dialog ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [9]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        }),
        _cache[15] || (_cache[15] = _createElementVNode("h1", null, " isDivided: false, hasFooter: false ", -1 /* CACHED */)),
        _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDialogBtn }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" width-lg ratio-full ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [10]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDialogBtn }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" width-md ratio-full ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [11]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDialogBtn }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode(" width-sm ratio-full ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [12]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickDialogBtn }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode(" width-xs ratio-full ")
                    ])),
                    _: 1 /* STABLE */,
                    __: [13]
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            outlined: true,
                            "size-m": true
                        }
                    ]
                ])
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
